import { createSelector } from 'reselect'

export const getCurrentParentUsertype = createSelector(
  state => state && state.user && state.user.registration && state.user.registration.currentParentUserType
    ? state.user.registration.currentParentUserType : null,
  usertype => usertype
)
